import { render, staticRenderFns } from "./TableCopy.vue?vue&type=template&id=3fc06d7d&"
import script from "./TableCopy.vue?vue&type=script&lang=js&"
export * from "./TableCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports